<template>
  <component
    :is="coursePageLayoutComponent"
    v-bind="$props"
  >
    <template #sidebar>
      <slot name="sidebar">
        <div
          v-if="enableSidebar"
          class="md:w-1/4 md:block ml-12 mb-8 hidden"
        >
          <SidebarContent />
        </div>
      </slot>
    </template>
  </component>
</template>

<script>
import CoursePageBaseLayout from '~contemporaryTheme/pages/courses/_id.baseLayout'
import CoursePageTabLayout from '~contemporaryTheme/pages/courses/_id.tabLayout'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { SIDEBAR, COURSE_PAGE_TAB_LAYOUT } from '@/constants/featureFlags'
import SidebarContent from '@/components/contemporaryTheme/components/SidebarContent'

export default {
  setup() {
    const { coursePageTabLayout, enableSidebar } = useFeatureFlags({
      coursePageTabLayout: COURSE_PAGE_TAB_LAYOUT,
      enableSidebar: SIDEBAR,
    })
    return { coursePageTabLayout, enableSidebar }
  },
  components: {
    SidebarContent,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coursePageLayoutComponent() {
      if (this.coursePageTabLayout) return CoursePageTabLayout
      return CoursePageBaseLayout
    },
  },
}
</script>
